module.exports = __webpack_public_path__ + "static/media/victoria.123d28e9.png";